var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58866 12.4113 -1.56865e-07 8 -3.49691e-07C3.58866 -5.42517e-07 -1.56865e-07 3.58866 -3.49691e-07 8C-5.42517e-07 12.4113 3.58866 16 8 16C12.4113 16 16 12.4113 16 8ZM7.52866 10.4713L4.19534 7.138C4.06534 7.008 4 6.83734 4 6.66666C4 6.496 4.06534 6.32531 4.19534 6.19531C4.456 5.93466 4.87734 5.93466 5.138 6.19531L8 9.05734L10.862 6.19534C11.1227 5.93469 11.544 5.93469 11.8047 6.19534C12.0653 6.456 12.0653 6.87734 11.8047 7.138L8.47131 10.4713C8.21066 10.732 7.78934 10.732 7.52866 10.4713Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWithBg);
export default __webpack_public_path__ + "static/media/down-with-bg.7ffdbe0a.svg";
export { ForwardRef as ReactComponent };